import type { EnvConfig } from '../types';

/**
 * Get environment configuration
 * In production, these should be set via Cloudflare Pages environment variables
 */
export function getEnvConfig(): EnvConfig {
  const blissApiBase =
    import.meta.env.VITE_BLISS_API_BASE ||
    import.meta.env.VITE_BLISS_API_BASE_URL ||
    'https://blissits.com';

  return {
    BLISS_PROJECT_ID: import.meta.env.VITE_BLISS_PROJECT_ID,
    BLISS_API_BASE: import.meta.env.VITE_BLISS_API_BASE,
    BLISS_API_BASE_URL: blissApiBase,
    STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
    R2_PUBLIC_URL: import.meta.env.VITE_R2_PUBLIC_URL,
  };
}

/**
 * Check if we're in development mode
 */
export function isDevelopment(): boolean {
  return import.meta.env.DEV;
}

/**
 * Check if we're in production mode
 */
export function isProduction(): boolean {
  return import.meta.env.PROD;
}

